import React from 'react';

const About = () => {
  return (
    <section className="bg-white py-10 px-6 md:px-16">
      <h1 className="text-4xl md:text-5xl font-semibold text-[#8B5E3C] mb-8">
        Sardar Jewellers – A choice you can trust
      </h1>

      <p className="text-gray-700 text-base leading-relaxed mb-4">
        At Sardar Jewellers, Trust is our Foundation. Choosing Sardar is not merely selecting jewellery;
        it's making a conscious decision to entrust your moments and milestones to a brand with a rich legacy
        of trust and integrity.
      </p>

      <p className="text-gray-700 text-base leading-relaxed mb-4">
        We have served generations with timeless designs. Would it have been possible without the unwavering trust
        of our loyal customers? Through years of craftsmanship and innovation, we’ve stayed committed to one thing —
        purity, quality, authenticity, and excellence in every piece we create. We stand behind every jewel we craft:
      </p>

      <ul className="list-disc list-inside text-gray-700 text-base mb-4 space-y-2">
        <li>
          <span className="font-semibold">BIS (Bureau of Indian Standards) 916 Hallmarked gold:</span> Easily verify the
          purity and fitness grade with the BIS logo and the Hallmark Unique Identification (HUID) number.
        </li>
        <li>
          <span className="font-semibold">Diamond Assurance:</span> Our diamonds undergo rigorous quality testing and grading by
          the International Gemological Institute (IGI) and the Gemological Institute of America (GIA), ensuring
          authenticity and quality.
        </li>
      </ul>

      <p className="text-gray-700 text-base leading-relaxed mb-2">
        But there’s more…
      </p>

      <p className="text-gray-700 text-base leading-relaxed mb-4">
        <span className="font-semibold">Transparency</span> in transactions is one of the foundations of trust. At Sardar Jewellers,
        we share every detail of your purchase — from gold weight and stone specifics to net weight, stone charge, and
        making charges. We don’t just build sales; we build relationships. Through openness, reliability, and lasting
        trust, we aim to give you an experience rooted in commitment. We value YOU.
      </p>
      <h2 className='text-1xl md:text-2xl font-semibold text-[#8B5E3C] mb-6'>So go ahead, let your jewellery do the talking with Sardar Jewellers!</h2>
    </section>
  );
};

export default About;
